export const SearchCategories = [
  {
    id: 'templates',
    name: 'Video Templates',
    slug: null,
  },
  {
    id: 'presets',
    name: 'Presets',
    slug: null,
  },
  {
    id: 'motion-graphics',
    name: 'Motion Graphics',
    slug: 'stock-motion-graphics',
  },
  {
    id: 'footage',
    name: 'Footage',
    slug: 'stock-video',
  },
  {
    id: 'music',
    name: 'Music',
    slug: 'royalty-free-music',
  },
  {
    id: 'sound-effects',
    name: 'Sound Effects',
    slug: 'sound-effects',
  },
  {
    id: 'graphics',
    name: 'Graphics',
    slug: 'graphics',
  },
  {
    id: 'photos',
    name: 'Photos',
    slug: 'stock-photos',
  },
  {
    id: '',
    name: 'All Categories',
    slug: null,
  },
];
